import React, { useState, useEffect } from 'react';
import { analyticsAPI } from '../services/api';
import { DollarSign, RefreshCw } from 'lucide-react';
import '../styles/CoinStatistics.css';
import logger from '../utils/logger';

const CoinStatistics = () => {
  const [coinData, setCoinData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    // Use setTimeout to make this truly non-blocking
    const timer = setTimeout(() => {
      fetchCoinData();
    }, 100); // Small delay to let dashboard render first

    return () => clearTimeout(timer);
  // eslint-disable-next-line react-hooks/exhaustive-deps -- run once on mount; fetchCoinData reads the state current at that time
  }, []);

  const fetchCoinData = async () => {
    try {
      // Don't set loading if we're just refreshing
      if (!refreshing) {
        setLoading(true);
      }
      
      const response = await analyticsAPI.getUserCoins();
      
      if (response && response.success) {
        setCoinData({
          month: response.data.month,
          totalCoins: response.data.total_coins,
          currency: response.data.currency || 'Coins'
        });
      } else {
        // Handle error response
        setCoinData({
          month: response?.data?.month || getCurrentMonth(),
          totalCoins: 'N/A'
        });
      }
    } catch (error) {
logger.error('COINSTATISTICS', 'Error fetching coin statistics:', { error: error });
      setCoinData({
        month: getCurrentMonth(),
        totalCoins: 'N/A'
      });
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  const getCurrentMonth = () => {
    return new Date().toLocaleDateString('en-US', { 
      month: 'long', 
      year: 'numeric' 
    });
  };

  const handleRefresh = async () => {
    setRefreshing(true);
    await fetchCoinData();
  };

  const isLoading = loading || refreshing;

  // Render immediately with placeholder while loading
  return (
    <div className="stat-card coins-card">
      <div className="stat-icon">
        <DollarSign size={24} />
      </div>
      <div className="stat-content">
        <div className="stat-header-with-refresh">
          <h3>Total Coins</h3>
          <button 
            className="coin-refresh-btn"
            onClick={handleRefresh}
            disabled={refreshing}
            aria-label="Refresh coin statistics"
          >
            <RefreshCw 
              className={`refresh-icon ${refreshing ? 'spinning' : ''}`} 
              size={14} 
            />
          </button>
        </div>
        <div className="stat-number">
          {isLoading ? (
            <span className="loading-dots">Loading</span>
          ) : (
            coinData?.totalCoins === 'N/A'
              ? 'N/A'
              : coinData.totalCoins
          )}
        </div>
        <div className="stat-meta">
          <span className="stat-trend">
            {coinData?.month || (isLoading ? '' : getCurrentMonth())}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CoinStatistics;